import type { JSX } from 'react';
import { SESSION_STATE_LABELS, type SessionState } from '@teams-avatar/shared';
import { Pill, type Tone } from './ui';

/**
 * Farbe pro Zustand. `lobby` ist bewusst warnfarbig: dort muss ein Mensch im
 * Meeting handeln, und das darf nicht wie ein normaler Zwischenschritt aussehen.
 *
 * `active` traegt als einziger Zustand die Markenfarbe — der Avatar ist dann
 * wirklich im Meeting, und das ist das Ziel des ganzen Werkzeugs.
 */
const TONES: Record<SessionState, Tone> = {
  pending: 'neutral',
  starting: 'neutral',
  joining: 'neutral',
  lobby: 'warning',
  active: 'brand',
  leaving: 'neutral',
  ended: 'muted',
  failed: 'danger',
};

const PULSING: ReadonlySet<SessionState> = new Set<SessionState>([
  'starting',
  'joining',
  'lobby',
  'leaving',
]);

export function StatusBadge({ state }: { state: SessionState }): JSX.Element {
  return (
    <Pill tone={TONES[state]} pulsing={PULSING.has(state)}>
      {SESSION_STATE_LABELS[state]}
    </Pill>
  );
}
